import { render } from "./ActivationPage.vue?vue&type=template&id=93c630d0"
import script from "./ActivationPage.vue?vue&type=script&lang=js"
export * from "./ActivationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__